import React from 'react'

const SymptomsCapture = ({ formData, setFormData, setCurrentStep }) => {
  const commonSymptoms = [
    'Fever',
    'Headache',
    'Cough',
    'Sore throat',
    'Runny nose',
    'Nausea',
    'Vomiting',
    'Diarrhea',
    'Fatigue',
    'Body aches'
  ]

  const handleSymptomToggle = (symptom) => {
    const newSymptoms = formData.symptoms.includes(symptom)
      ? formData.symptoms.filter((s) => s !== symptom)
      : [...formData.symptoms, symptom]
    setFormData({ ...formData, symptoms: newSymptoms })
  }

  return (
    <div className='step-container'>
      <h2>Symptoms</h2>
      <p>
        <b>{formData.patientRecord.firstName}</b>, please select all symptoms you are experiencing
      </p>
      <div className='symptoms-grid'>
        {commonSymptoms.map((symptom) => (
          <label key={symptom} className='checkbox-item'>
            <input
              type='checkbox'
              checked={formData.symptoms.includes(symptom)}
              onChange={() => handleSymptomToggle(symptom)}
            />
            <span>{symptom}</span>
          </label>
        ))}
      </div>
      <div className='input-group'>
        <label htmlFor='additional-symptoms'>Additional symptoms (optional)</label>
        <textarea
          id='additional-symptoms'
          value={formData.additionalSymptoms}
          onChange={(e) => setFormData({ ...formData, additionalSymptoms: e.target.value })}
          placeholder='Describe any other symptoms...'
          rows='3'
        />
      </div>
      <button onClick={() => setCurrentStep(4)} className='btn-primary'>
        Continue
      </button>
    </div>
  )
}

export default SymptomsCapture
